<template>
  <div>
    <div class="WorkM_AttendanceCheckHeader">
        <!-- 日付選択 -->
        <div class="WorkM_ChangeTargetDateArea d-flex">
            <div class="ChangeTargetDateButton"><b-icon icon="chevron-left" @click="clickBeforeDate()"></b-icon></div>
            <div style="" class="DispYearMonthDate">
                {{ dispDate }} ({{ dispDayOfWeek }}) 
            </div>
            <div class="ChangeTargetDateButton"><b-icon icon="chevron-right" @click="clickNextDate()"></b-icon></div>
        </div>
        <div class="WorkM_ChangeTargetSelect py-2">
            <b-container class="d-flex justify-content-center">
                <b-col cols="6" class="WorkM_SelectPart mx-1 px-0">
                    <div>本社/支店</div>
                    <b-select :options="optionOffice_group" v-model="selectOffice" @change="getAttendanceListOffice()" :items="optionOffice" value-field="office_code" text-field="office_name"></b-select>
                </b-col>
                <b-col cols="6" class="WorkM_SelectPart mx-1 px-0"></b-col>
            </b-container>
            <b-container class="d-flex justify-content-center">
                <b-col cols="6" class="WorkM_SelectPart mx-1 px-0">
                    <div>部</div>
                    <b-select :options="optionPart_group" v-model="selectPart" @change="getAttendanceListPart()" :items="optionPart" value-field="key" text-field="part_name"></b-select>
                </b-col>
                <b-col cols="6" class="WorkM_SelectSection mx-1 px-0">
                    <div>課</div>
                    <b-select :options="optionSection_group" v-model="selectSection" @change="getAttendanceListSection()" :items="optionSection" value-field="key" text-field="section_name"></b-select>
                </b-col>
            </b-container>
        </div>
    </div>
    <main style="max-height: calc(100svh - 110px - 190px);">
        <div class="WorkM_MainArea">
            <b-container fluid style="max-width: 500px">
                <!-- 在席一覧 -->
                <b-container class="WorkM_AttendanceCheck">
                    <b-row>
                        <b-col cols="6" v-for="workInfoItem in attendanceList" :key="workInfoItem.i" class="px-1 position-relative">
                            <div v-if="getDispSegment(workInfoItem.attendanceType) == 1" 
                            class="WorkInfoItem WorkM_AttendanceList d-flex mx-1 my-1 position-relative">
                                <div class="workerStatus position-absolute">
                                    <div class="workerRest">休</div>
                                </div>
                                <div class="workerName d-inline-block text-truncate text-center">
                                    {{ workInfoItem.name }}
                                </div>
                            </div>
                            <div v-else-if="getDispSegment(workInfoItem.attendanceType) == 2" 
                            class="WorkInfoItem WorkM_AttendanceList d-flex mx-1 my-1 position-relative">
                                <div class="workerStatus position-absolute">
                                    <div class="workerRest">部分休</div>
                                </div>
                                <div class="workerNamePartialRest d-inline-block text-truncate text-center">
                                    {{ workInfoItem.name }}
                                </div>
                            </div>
                            <div v-else 
                            class="WorkInfoItem WorkM_AttendanceList d-flex mx-1 my-1 position-relative">
                                <div class="attendanceWorkerName d-inline-block text-truncate text-center">
                                    {{ workInfoItem.name }}
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </b-container>
            </b-container>
        </div>
    </main>
  </div>
</template>

<script>
import config from "../const/config";
export default {
    name: "AttendanceCheck",
    data: function(){
        return{
            systemVersion: null,
            dispDate: null,
            dispDayOfWeek: null,
            // 本社/支店選択
            optionOffice: [],
            selectOffice: null,
            // 部選択
            optionPart: [],
            selectPart: {"office_code":null, "part_code":null},
            // 課選択
            optionSection: [],
            selectSection: {"office_code":null, "part_code":null, "section_code":null},
            attendanceList: [],
            isFirstScreenStartup: true,
        }
    },
    computed: {
        // 支店変更時に使用
        defaultPart: function(){
            return {"office_code":this.selectOffice, "part_code":null};
        },
        // 部署変更時に使用
        defaultSection: function(){
            console.log(JSON.stringify(this.selectPart));
            return {"office_code":this.selectOffice, "part_code":this.selectPart.part_code, "section_code":null};
        },
        // 支店リスト
        optionOffice_group: function(){
            let arr = [];
            arr = arr.concat({"office_code":null, "office_name":"（すべて）"});
            if(this.optionOffice !== undefined){
                arr = arr.concat(this.optionOffice);
            }
            return arr;
        },
        // 部署リスト
        optionPart_group: function(){
            let arr = [];
            arr = arr.concat({"key":this.defaultPart, "part_name":"（すべて）"});
            if(this.optionPart !== undefined){
                console.log("this.optionPart:" + JSON.stringify(this.optionPart));
                if(this.selectOffice == null){
                    arr = arr.concat(this.optionPart);
                    return arr;
                }
                let partListByselectedOffice =  this.optionPart.filter((part)=>{
                    return part.key.office_code===this.selectOffice
                });
                arr = arr.concat(partListByselectedOffice);
                console.debug(JSON.stringify(arr));
            }
            return arr;
        },
        // 課リスト
        optionSection_group: function(){
            let arr = [];
            console.log(JSON.stringify(this.defaultSection));
            arr = arr.concat({"key":this.defaultSection, "section_name":"（すべて）"});
            if(this.optionSection !== undefined){
                if(this.selectPart.office_code == null && this.selectPart.part_code == null){
                    arr = arr.concat(this.optionSection);
                    return arr;
                }
                console.log(JSON.stringify(this.optionSection));
                let sectionListByselectedPart = this.optionSection.filter((section)=>{
                    if(this.selectPart.part_code == null){
                        return section.key.office_code===this.selectOffice
                    }
                    else{
                        return section.key.office_code===this.selectPart.office_code && section.key.part_code===this.selectPart.part_code
                    }
                });
                arr = arr.concat(sectionListByselectedPart);
                console.debug(JSON.stringify(arr));
            }
            return arr;
        }
    },

    mounted: function () {
        this.loginUserId = this.$store.state.user_id;
        this.getFirstAttendanceList();
    },

    methods:{
        // 表示されている日付の1日前の在席一覧を表示する
        clickBeforeDate: function () {
            this.dispDate = this.getBeforeDate(this.dispDate);
            this.dispDate = this.getStrDateSlash(this.dispDate);
            this.dispDayOfWeek = this.getDayOfWeek(this.dispDate);
            this.getAttendanceListSection();
        },
        // 表示されている日付の1日後の在席一覧を表示する
        clickNextDate: function () {
            this.dispDate = this.getNextDate(this.dispDate);
            this.dispDate = this.getStrDateSlash(this.dispDate);
            this.dispDayOfWeek = this.getDayOfWeek(this.dispDate);
            this.getAttendanceListSection();
        },
        // attendanceTypeによって出勤、全休、部分休か判断する
        getDispSegment: function (segmentCd) {
            // 0の場合表示しない
            if(segmentCd == 0){
                return 0;
            }
            // 1の場合「休」
            else if(segmentCd == 1){
                return 1;
            }
            // 2の場合「部分休」
            else if(segmentCd == 2){
                return 2;
            }
            else{
                return 0;
            }
        },
        // APIから画面に最初に表示する在席一覧を取得する
        getFirstAttendanceList: function(){
            let paramList = {
                shainCd: this.loginUserId,
            }
            console.debug("paramList：" + paramList);
            this.getWithParams(config.URL.ATTENDANCE_CHECK, paramList)
                .then((response) => {
                    console.debug("response：" + JSON.stringify(response));
                    // レスポンスの結果がfalseならエラーメッセージを表示
                    if(!response.result){
                        this.showAlertError(config.MESSAGE.SERVER_ERROR);
                        return;
                    }
                    this.setAttendanceList(response.container);
                    // 画面初期起動時は部選択、課選択をセットする
                    this.setOption(response.container);
                    this.dispDate = this.getStrDateSlash(response.container["targetDate"]);
                    this.dispDayOfWeek = this.getDayOfWeek(this.dispDate);
                })
                .catch((e) => {
                    // Note: エラーメッセージは、共通処理で表示している
                    console.error(e);
                })
                .finally(() => {});
        },
        
        // APIから本支店コードに合った在席一覧を取得する
        getAttendanceListOffice: function(){
            let paramList = {
                shainCd: this.loginUserId,
                targetDate: this.dispDate,
                targetOffice: this.selectOffice,
            };
            this.getWithParams(config.URL.ATTENDANCE_CHECK, paramList)
                .then((response) => {
                    console.log("response：" + JSON.stringify(response));
                    // レスポンスの結果がfalseならエラーメッセージを表示
                    if(!response.result){
                        this.showAlertError(config.MESSAGE.SERVER_ERROR);
                        return;
                    }
                    this.selectPart = this.defaultPart;
                    console.log("selectPart:"+JSON.stringify(this.selectPart));
                    this.selectSection = this.defaultSection;
                    this.setAttendanceList(response.container);
                    this.setOption(response.container);
                })
                .catch((e) => {
                    // Note: エラーメッセージは、共通処理で表示している
                    console.error(e);
                })
                .finally(() => {});
        },
        // APIから部コードに合った在席一覧を取得する
        getAttendanceListPart: function(){
            let paramList = {
                shainCd: this.loginUserId,
                targetDate: this.dispDate,
                targetOffice: this.selectPart.office_code,
                targetPart: this.selectPart.part_code,
            };
            console.log("paramList:" + JSON.stringify(paramList));
            this.getWithParams(config.URL.ATTENDANCE_CHECK, paramList)
                .then((response) => {
                    console.debug("response：" + JSON.stringify(response));
                    // レスポンスの結果がfalseならエラーメッセージを表示
                    if(!response.result){
                        this.showAlertError(config.MESSAGE.SERVER_ERROR);
                        return;
                    }
                    this.selectSection = this.defaultSection;
                    this.setAttendanceList(response.container);
                    this.setOption(response.container);
                })
                .catch((e) => {
                    // Note: エラーメッセージは、共通処理で表示している
                    console.error(e);
                })
                .finally(() => {});
        },
        // APIから課コードに合った在席一覧を取得する
        getAttendanceListSection: function(){
            let paramList = {
                shainCd: this.loginUserId,
                targetDate: this.dispDate,
                targetOffice: this.selectSection.office_code,
                targetPart: this.selectSection.part_code,
                targetSection: this.selectSection.section_code
            };
            this.getWithParams(config.URL.ATTENDANCE_CHECK, paramList)
                .then((response) => {
                    console.debug("response：" + JSON.stringify(response.container));
                    // レスポンスの結果がfalseならエラーメッセージを表示
                    if(!response.result){
                        this.showAlertError(config.MESSAGE.SERVER_ERROR);
                        return;
                    }
                    this.setAttendanceList(response.container);
                    this.setOption(response.container);
                })
                .catch((e) => {
                    // Note: エラーメッセージは、共通処理で表示している
                    console.error(e);
                })
                .finally(() => {});
        },
        // JSON形式で取得した情報を在席一覧にセットする
        setAttendanceList: function(items){
            this.attendanceList = items.memberInfo;
        },
        // 本社/支店選択、部選択、課選択をセットする
        setOption: function(items){
            console.debug(items);
            // 本社/支店一覧にセット
            this.optionOffice = items.officeList;
            console.debug("optionOffice：" + JSON.stringify(this.optionOffice));
            // 部選択一覧にセット
            this.optionPart = items.partList;
            console.debug("optionPart：" + JSON.stringify(this.optionPart));
            // 課選択一覧にセット
            this.optionSection = items.sectionList;
            console.debug("optionSection：" + JSON.stringify(this.optionSection));
        }
    }
}
</script>
<style>
.WorkM_AttendanceCheckHeader {
    position: sticky;
    top: 0;
    z-index: 999;
}
.WorkM_ChangeTargetDateArea {
    justify-content: space-around;
    width: 100%;
    text-align: center;
    background: #ececec;
    border-bottom: 1px solid rgb(241, 241, 241);
    padding: 0.3rem;
    padding-right: 1rem;
    padding-left: 2rem;
    font-size: 1.2rem;
}
.WorkM_SelectPart {
    width: 10rem;
}
.WorkM_SelectSection{
    width: 10rem;
}
.WorkM_ChangeTargetSelect{
    background-color: #f8f8f8;
    font-size: 0.8rem;
}

.WorkM_AttendanceList{
    background: rgb(248, 248, 248);
    border-radius: 5px;
    font-size: 0.9rem;
    height: 2rem;
}
.workerStatus{
    display: flex;
    align-items: left;
    min-width: 2rem;
    height: 100%;
}
.WorkM_AttendanceCheck{
    background: #e0efff;
}
.workerRest{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px 0 0 5px;
    color: rgb(241, 241, 241);
    background: rgb(207, 90, 90);
    height: 100%;
    width: 100%;
}
.workerRestColor{
    border: 1px solid rgb(207, 90, 90);
}
.workerWork{
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px 0 0 5px;
    color: rgb(241, 241, 241);
    background: rgb(40, 123, 201);
    height: 100%;
    width: 100%;
}
.workerWorkColor{
    border: 1px solid rgb(40, 123, 201);
}
.workerName{
    margin-left: 2rem;
    margin-top: auto;
    margin-bottom: auto;
    width:100%;
}
.workerNamePartialRest{
    margin-left: 3rem;
    margin-top: auto;
    margin-bottom: auto;
    width:100%;
}
.attendanceWorkerName{
    width: 100%;
    /* workerStatusに合わせる */
    margin-top: auto;
    margin-bottom: auto;
}
/* .workerName{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-right: 2rem; 
} */
</style>